import { LoanActivity, loanEventTypeMessages } from '@api';
import { Avatar, Typography } from '@mui/material';
import { formatPastDate, useGetUserWithColorById } from '@utils';
import LoanNumberLink from '@views/components/MainNav/components/NotificationsButton/components/LoanNumberLink';
import { Markdown } from '@views/components/Markdown';

import styles from './ActivityStreamItem.module.scss';
import { UserTooltip } from './UserTooltip';


interface ActivityStreamItemProps {
  loanActivity: LoanActivity;
}

export function ActivityStreamItem({ loanActivity }: ActivityStreamItemProps) {
    const user = useGetUserWithColorById(loanActivity.userId);
    const { loanNumber, loanId } = loanActivity;

    return (
        <div className={styles.activityStreamItem}>
            {user ? (
                <UserTooltip user={user}>
                    <Avatar
                        className={styles.avatar}
                        sx={{ bgcolor: user.avatarColor }}
                    >
                        {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
                    </Avatar>
                </UserTooltip>
            ) : (
                <Avatar>Unknown</Avatar>
            )}

            <div>
                <Typography
                    variant="body2"
                    className={styles.activityStreamMessage}
                >
                    <Markdown>
                        {loanEventTypeMessages[loanActivity.type]}
                    </Markdown>
                </Typography>

                <div className={styles.activityStreamBottomRow}>
                    <LoanNumberLink
                        color="textPrimary"
                        loanNumber={loanNumber}
                        loanId={loanId}
                    />

                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        {formatPastDate(loanActivity.date)}
                    </Typography>
                </div>
            </div>
        </div>
    );
}
